<template>
    <div class="bannerclass" :class="isVideo ? 'is-video' : className ? className : ''">
        <!-- 视频模式 -->
        <div v-if="isVideo" class="video-container">
            <video
                :height="dataHeight"
                class="banner-video-class"
                autoplay
                muted
                loop
                playsinline
            >
                <source
                    src="https://cdn.spbcn.org/spbcnWeb/cebsb/new/3nd_photo/threeFinalVideo-1103.mp4"
                    type="video/mp4"
                />
                您的浏览器不支持视频播放。
            </video>
        </div>
        <img v-else :src="bannerimg[0].url" alt="" class="banner-img-class" :class="className" />
        <!-- 图片轮播模式 -->
        <!-- <el-carousel
            v-else
            :interval="3000"
            indicator-position="none"
            id="el-carousel"
            :height="dataHeight"
        >
            <el-carousel-item v-for="item in bannerimg" :key="item.index">
                <img :src="item.url" alt="" class="banner-img-class" />
            </el-carousel-item>
        </el-carousel> -->
        <div class="banner-bottomLine"></div>

        <div class="translucent-backview">
            <div class="translucent-contentview">
                <!-- HomeView 样式 -->
                <template v-if="type === 'home' || type === 'global'">
                    <div class="flex1">
                        <img class="title-img animate__animated animate__fadeInLeft" src="https://cdn.spbcn.org/spbcnWeb/cebsb/web/jiangbei.png" alt="">
                        <div>
                            <div
                                class="translucent-titleStr animate__animated animate__fadeInLeft"
                            >
                                The 4th CEBSB Global Finals
                            </div>
                            <div
                                class="translucent-subtitle animate__animated animate__fadeInLeft"
                            >
                                Date: October 30 – November 1, 2026
                            </div>
                            <div class="translucent-subtitle animate__animated animate__fadeInLeft">
                                Venue: Hangzhou, China
                            </div>
                        </div>
                    </div>
                    <button v-if="type === 'home'"
                        class="signup-button animate__animated animate__fadeInLeft"
                        @click="handleSignUp"
                    >
                        SIGN UP →
                    </button>
                    <!-- <div v-if="type === 'global'" class="banner-slogan-box animate__animated animate__fadeInLeft" @click="regFn">
                        Registration Process for Global Finals
                    </div> -->
                    <button v-if="type === 'global'"
                        class="signup-button animate__animated animate__fadeInLeft mb-20"
                        @click="regFn"
                    >
                        Registration Process for Global Finals →
                    </button>
                    <button v-if="type === 'global'"
                        class="signup-button animate__animated animate__fadeInLeft"
                        @click="regFn2"
                    >
                        Quick Inquiry →
                    </button>
                </template>
                <template v-else-if="type === 'elearn'">
                    <div class="flex3">
                        <img class="title-img animate__animated animate__fadeInLeft" src="https://cdn.spbcn.org/spbcnWeb/cebsb/web/jiangbei.png" alt="">
                        <div>
                            <div
                                class="banner-title-line1 animate__animated animate__fadeInLeft"
                            >
                                E-LEARN
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else-if="type === 'join'">
                    <div class="flex3">
                        <img class="title-img animate__animated animate__fadeInLeft" src="https://cdn.spbcn.org/spbcnWeb/cebsb/web/jiangbei.png" alt="">
                        <div>
                            <div
                                class="banner-title-line1 animate__animated animate__fadeInLeft"
                            >
                                Become
                            </div>
                            <div
                                class="banner-title-line2 animate__animated animate__fadeInLeft"
                            >
                                Global Partner
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else-if="type === 'faq'">
                    <div class="flex3">
                        <img class="title-img animate__animated animate__fadeInLeft" src="https://cdn.spbcn.org/spbcnWeb/cebsb/web/jiangbei.png" alt="">
                        <div>
                            <div
                                class="banner-title-line1 animate__animated animate__fadeInLeft"
                            >
                                Frequently Asked
                            </div>
                            <div
                                class="banner-title-line2 animate__animated animate__fadeInLeft"
                            >
                                Questions
                            </div>
                        </div>
                    </div>
                </template>
                <!-- 其他页面样式 -->
                <template v-else>
                    <div class="flex1">
                        <img class="title-img animate__animated animate__fadeInLeft" src="https://cdn.spbcn.org/spbcnWeb/cebsb/web/jiangbei.png" alt="">
                        <div>
                            <div
                                class="banner-title-line1 animate__animated animate__fadeInLeft"
                            >
                                CHINESE-ENGLISH BILINGUAL
                            </div>
                            <div
                                class="banner-title-line2 animate__animated animate__fadeInLeft"
                            >
                                SPELLING BEE
                            </div>
                            <div
                                class="banner-slogan-box animate__animated animate__fadeInLeft"
                            >
                                WORD ENLIGHTENS WORLD
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    bannerimg: Array,
    dataHeight: {
      type: String,
      default: '100%'
    },
    isVideo: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    className: {
      type: String
    }
  },
  data () {
    return {
    }
  },
  computed: {
    isHomeView () {
      // 判断当前路由是否是首页
      const path = this.$route.path
      return path === '/' || path === '/HomeView' || path === '/home'
    }
  },
  methods: {
    handleSignUp () {
      // 判断是否登录
      const token = localStorage.getItem('Authorization')
      if (token) {
        // 已登录，跳转到学生主页
        this.$router.push('/stu/dashboard')
      } else {
        // 未登录，跳转到登录页面
        this.$router.push('/chnEngLogin')
      }
    },
    regFn () {
      this.$emit('reg')
    },
    regFn2 () {
      this.$emit('reg2')
    }
  }
}
</script>

<style>
.mb-20{
    margin-bottom: 20px;
}
.bannerclass {
    width: 100%;
    height: 550px;
}
.bannerclass.is-video {
    height: 100%;
}
.banner-img-class {
    width: 100%;
    height: 550px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    -moz-background-size: 100% 100%;
    object-fit: cover;
    object-position: center;
}

.elearnheight {
    height: 340px;
}
.faqheight{
    height: 340px;
}

/* 视频容器样式 */
.video-container {
    width: 100%;
    height: 550px;
    position: relative;
    overflow: hidden;
}
.bannerclass.is-video .video-container {
    height: 550px;
}
.banner-bottomLine {
    width: 100%;
    height: 6px;
    background-color: #b30011;
}
.banner-video-class {
    width: 100%;
    height: 550px;
    object-fit: cover;
    object-position: center;
}
.bannerclass.is-video .banner-video-class {
    height: 550px;
}
.el-carousel {
    width: 100%;
    height: 550px;
}
.translucent-backview {
    width: 100%;
    height: 550px;
    position: relative;
    top: -550px;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5));
    z-index: 1001;
}
.bannerclass.is-video .translucent-backview {
    height: 550px;
    top: -550px;
}
.translucent-contentview {
    width: auto;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-end;
    padding: 40px;
    position: absolute;
    left: 0;
    bottom: 0;
    max-width: 1400px;
}
.translucent-titleStr {
    height: auto;
    line-height: 1;
    font-size: 36px;
    font-weight: 700;
    padding: 0;
    margin-bottom: 8px;
    font-family: Impact, "Arial Black", sans-serif;
    color: #ffffff;
    text-align: left;
}
.translucent-titleStr2 {
    height: auto;
    line-height: 1;
    margin: 0 0 20px 0;
    font-size: 28px;
    font-weight: 700;
    padding: 0;
    font-family: Impact, "Arial Black", sans-serif;
    color: #ffffff;
    text-align: left;
    animation-delay: 0.2s;
}
.translucent-subtitle {
    height: auto;
    line-height: 1;
    font-size: 15px;
    font-weight: 400;
    padding: 0;
    /* margin: 0 0 8px 0; */
    margin: 4px 0 10px 0;
    font-family: Impact, "Arial Black", sans-serif;
    color: #ffffff;
    text-align: left;
    animation-delay: 0.4s;
}
.translucent-subtitle2 {
    height: auto;
    line-height: 1;
    font-size: 15px;
    font-weight: 400;
    padding: 0;
    margin: 0 0 24px 0;
    font-family: Impact, "Arial Black", sans-serif;
    color: #ffffff;
    text-align: left;
    animation-delay: 0.6s;
}
.signup-button {
    padding: 12px 32px;
    font-size: 14px;
    font-weight: 600;
    color: #811d21;
    background-color: #ffffff;
    border: 2px solid #811d21;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-family: Impact, "Arial Black", sans-serif;
    animation-delay: 0.8s;
    outline: none;
}
.signup-button:hover {
    background-color: #811d21;
    color: #ffffff;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(129, 29, 33, 0.3);
}
.signup-button:active {
    transform: translateY(0);
}
/* 其他页面的 banner 样式 */
.banner-title-line1 {
    height: auto;
    line-height: 1;
    font-size: 42px;
    font-weight: 700;
    padding: 0;
    font-family: Impact, "Arial Black", sans-serif;
    color: #ffffff;
    text-align: left;
}
.banner-title-line2 {
    height: auto;
    line-height: 1;
    margin: 0 0 14px 0;
    font-size: 42px;
    font-weight: 700;
    padding: 0;
    font-family: Impact, "Arial Black", sans-serif;
    color: #ffffff;
    text-align: left;
    animation-delay: 0.2s;
}
.banner-slogan-box {
    height: auto;
    line-height: 1.4;
    font-size: 20px;
    font-weight: 700;
    padding: 6px 15px;
    margin: 0;
    font-family: alim;
    color: #821e21;
    background-color: #fff;
    border-radius: 40px;
    text-align: left;
    display: inline-block;
    animation-delay: 0.4s;
    cursor: pointer;
}
.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
}
.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}
.el-carousel__item:nth-child(2n + 1) {
    background-color: #d3dce6;
}

.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
}
.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}
.el-carousel__item:nth-child(2n + 1) {
    background-color: #d3dce6;
}
:root {
    --animate-delay: 0.5s;
}
.flex1{
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;
    .title-img{
        width: 40px;
        height: 90px;
        object-fit: contain;
        margin-right: 20px;
    }
}
</style>
